<template>
  <div class="value-proposition">
    <h2
      class="value-proposition__header value-proposition__header"
      v-html="$t('b2b__landing_page__value_proposition__title')"
    />
    <div class="value-proposition-sections">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="value-proposition-section"
      >
        <img
          :src="card.image"
          class="value-proposition-section__banner"
          :alt="card.title"
        />
        <div class="value-proposition-info kds-content-block">
          <h3
            class="kds-typography-display-small"
            v-html="card.title"
          />
          <div
            class="kds-typography-paragraph-large"
            v-html="card.description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'petite-vue-i18n'
import lifeFitImage from '@shared/assets/img/life_fit_4x.png'
import provenMethodsImage from '@shared/assets/img/proven_methods_4x.png'
import costsCoveredImage from '@shared/assets/img/costs_covered_4x.png'
import reclaimingLiveImage from '@shared/assets/img/reclaiming-life-image-two.png'
import env from '@shared/env.js'

const { t } = useI18n()

const cards = [
  {
    title: t('b2b__landing_page__value_proposition__life_fit__title'),
    description: t(
      'b2b__landing_page__value_proposition__life_fit__description',
    ),
    image: env.isMsk ? lifeFitImage : costsCoveredImage,
  },
  {
    title: t('b2b__landing_page__value_proposition__proven_methods__title'),
    description: t(
      'b2b__landing_page__value_proposition__proven_methods__description',
    ),
    image: provenMethodsImage,
  },
  {
    title: t('b2b__landing_page__value_proposition__costs_covered__title'),
    description: t(
      'b2b__landing_page__value_proposition__costs_covered__description',
    ),
    image: env.isMsk ? costsCoveredImage : reclaimingLiveImage,
  },
]
</script>

<style lang="scss" scoped>
.value-proposition {
  background-color: $kds-color-background-blue-strong;

  &__header {
    margin: 0;
    padding: 45px 24px 28px;
    text-align: center;

    @include kds-typography-display-small;
  }

  &-sections {
    display: flex;
    flex-direction: column;
    padding: 0 24px;
  }

  &-section {
    &__banner {
      display: block;
      max-width: 100%;
    }
  }

  &-info {
    padding: 24px 0 54px;
  }
}

.value-proposition {
  @include media-up(sm) {
    padding-bottom: 12px;
  }

  @include media-up(md) {
    padding-bottom: 36px;
  }

  @include media-up(lg) {
    padding-bottom: 72px;
  }

  @include media-up(xl) {
    padding-bottom: 96px;
  }

  &__header {
    @include media-up(sm) {
      padding-top: 48px;
      padding-bottom: 36px;
    }

    @include media-up(md) {
      @include kds-typography-display-medium;

      padding: 72px 100px 36px;
    }

    @include media-up(lg) {
      padding: 72px 200px 36px;
    }

    @include media-up(xl) {
      @include kds-typography-display-large;

      padding: 96px 200px 36px;
    }

    @include media-up(xxl) {
      padding: 96px 200px 48px;
    }
  }

  &-sections {
    @include media-up(sm) {
      padding: 0 24px;
    }

    @include media-up(md) {
      padding: 0 54px;
    }

    @include media-up(lg) {
      flex-direction: row;
      justify-content: space-between;
      padding: 0 82px;
    }

    @include media-up(xxl) {
      max-width: 1200px;
      margin: 0 auto;
    }
  }

  &-section {
    @include media-up(md) {
      display: flex;
      padding-bottom: 36px;
    }

    @include media-up(lg) {
      display: block;
      flex-basis: 30%;
      padding-bottom: 0;
    }

    @include media-up(xl) {
      flex-basis: 31%;
    }

    &__banner {
      @include media-up(md) {
        max-height: 204px;
        margin: 0 auto;
      }

      @include media-up(xl) {
        max-height: 215px;
      }
    }
  }

  &-info {
    @include media-up(sm) {
      padding-bottom: 36px;
    }

    @include media-up(md) {
      padding: 0 0 0 30px;
      flex-basis: 50%;
    }

    @include media-up(lg) {
      padding-top: 18px;
      padding-left: 0;
    }

    @include media-up(xxl) {
      padding-top: 24px;
    }

    &__title {
      @include media-up(lg) {
        margin-bottom: 13px;
      }
    }
  }
}
</style>
